import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { localeFromPath } from "@/i18n/localePath";
import { useTranslation } from "@/i18n/useTranslation";

const LocalePathSync = () => {
  const location = useLocation();
  const { locale, setLocale } = useTranslation();
  const pathLocale = localeFromPath(location.pathname);

  useEffect(() => {
    if (locale !== pathLocale) setLocale(pathLocale);
  }, [locale, pathLocale, setLocale]);

  return null;
};

export default LocalePathSync;
